import { render, staticRenderFns } from "./ActividadReciente.vue?vue&type=template&id=29da69fe&scoped=true"
import script from "./ActividadReciente.vue?vue&type=script&lang=js"
export * from "./ActividadReciente.vue?vue&type=script&lang=js"
import style0 from "./ActividadReciente.vue?vue&type=style&index=0&id=29da69fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da69fe",
  null
  
)

export default component.exports